//ecd:-684308853H20261022084009_V3.0
/**
 * OrderStatus
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
export const OrderStatus = {
    PLACED: "PLC",
    SHIPPED: "SHP",
    CANCELLED: "CAN"
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


/** The constant a wire value stands for, or undefined. */
export function orderStatusOf(value: string | null | undefined): OrderStatus | undefined{
    if (value == null) return undefined;
    return Object.values(OrderStatus).find((v) => v === value) as OrderStatus | undefined;
}

/** What a screen shows for each value. */
export const OrderStatusLabel: Record<OrderStatus, string> = {
    [OrderStatus.PLACED]: "Placed",
    [OrderStatus.SHIPPED]: "Shipped",
    [OrderStatus.CANCELLED]: "Cancelled",
};
